// src/config/msalConfig.js
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
        authority: "https://login.microsoftonline.com/common",
        redirectUri: "https://apply-bridge-backend-91ee748b332f.herokuapp.com/applybridge/auth/outlook/callback",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};